import { FINANCE_EMPLOYEE_COST } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../resources/serviceURLs';

const getAppOrigin = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  return '';
};

export const getEmployeeCostDetailsBaseURL = () => {
  const serviceURL = appendServiceNameToURL(serviceName.RESELLER_SERVICE);
  const servicePort = appendServicePortToURL(serviceName.RESELLER_SERVICE);
  const envBaseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const originUrl = getAppOrigin();
  const baseUrl = envBaseUrl || originUrl;

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${FINANCE_EMPLOYEE_COST}`;
  }

  const nonProdBase = envBaseUrl
    ? envBaseUrl
    : originUrl.replace(/:\d+$/, '');

  return `${nonProdBase}:${servicePort}${serviceURL}/api${FINANCE_EMPLOYEE_COST}`;
};
